<div class="community-page">
  <h1 class="sr-only">Community feed page</h1>
  <h2 class="community-page__title" tabindex="-1">Welcome back, {{ user.name }}</h2>

  <div class="community-page__layout">
    <div class="community-page__main">
      <ut-community-featured class="community-page__featured" [feed]="featured()" [skipTarget]="afterFeatured"></ut-community-featured>
      <div class="community-page__stream" tabindex="-1" #afterFeatured>
        @if (!user.is_light_tester) {
          <ut-community-status-composer (posted)="feed.prepend($event)"></ut-community-status-composer>
        } @else {
          <div class="community-page__notice" role="status">
            <span class="material-icons community-page__notice-icon" aria-hidden="true">info_outline</span>
            <p class="community-page__notice-text">
              You are unable to post or interact with the community until you complete the required fields in your tester profile and add at least one testing device.
            </p>
            <a class="ut-btn ut-btn--secondary ut-btn--sm" [href]="testerAppUrl()">Update Profile</a>
          </div>
        }
        <ut-community-feed [user]="user" (itemCommented)="syncTrending($event)"></ut-community-feed>
      </div>
    </div>

    <aside class="community-page__aside">
      <ut-community-trending class="community-page__trending" [feed]="trending()"></ut-community-trending>
      <div class="community-page__card community-page__cta">
        <img class="community-page__cta-icon" src="/utest-static/assets/images/article.svg" alt="" />
        <h3 class="community-page__cta-title">Share your knowledge</h3>
        <a class="ut-btn ut-btn--sm" uiSref="newarticle" (click)="checkLightTester($event)">Write an Article</a>
      </div>
    </aside>
  </div>
  @if (showBackToTop()) {
    <button type="button" class="ut-btn ut-btn--secondary community-page__top" (click)="backToTop()">
      <span class="material-icons" aria-hidden="true">arrow_upward</span>
      Back to top
    </button>
  }
</div>
